// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gportal/type/v1/paranoid.proto (package gportal.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum gportal.type.v1.Paranoid
 */
export enum Paranoid {
  /**
   * @generated from enum value: PARANOID_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PARANOID_OFF = 1;
   */
  OFF = 1,

  /**
   * @generated from enum value: PARANOID_NORMAL = 2;
   */
  NORMAL = 2,

  /**
   * @generated from enum value: PARANOID_STRICT = 3;
   */
  STRICT = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(Paranoid)
proto3.util.setEnumType(Paranoid, "gportal.type.v1.Paranoid", [
  { no: 0, name: "PARANOID_UNSPECIFIED" },
  { no: 1, name: "PARANOID_OFF" },
  { no: 2, name: "PARANOID_NORMAL" },
  { no: 3, name: "PARANOID_STRICT" },
]);

